import { render, staticRenderFns } from "./CreatePermissionGroup.vue?vue&type=template&id=24226b16&scoped=true&"
import script from "./CreatePermissionGroup.vue?vue&type=script&lang=js&"
export * from "./CreatePermissionGroup.vue?vue&type=script&lang=js&"
import style0 from "./CreatePermissionGroup.vue?vue&type=style&index=0&id=24226b16&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24226b16",
  null
  
)

export default component.exports